import { render, staticRenderFns } from "./logisticsManagementBoundary.vue?vue&type=template&id=65da4aed&scoped=true&"
import script from "./logisticsManagementBoundary.vue?vue&type=script&lang=js&"
export * from "./logisticsManagementBoundary.vue?vue&type=script&lang=js&"
import style0 from "./logisticsManagementBoundary.vue?vue&type=style&index=0&id=65da4aed&scoped=true&lang=css&"
import style1 from "./logisticsManagementBoundary.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65da4aed",
  null
  
)

export default component.exports